import { Route, Routes } from "react-router-dom";
import ResourceNotFound from "../../../Common/ResourceNotFound";
import PaymentIn from "../ReceiptAndPaymentOut/Table/PaymentIn";
import LedgerTable from "../../Master/Ledger/LedgerTable";
import { SearchLedgerByGroupsTypes } from "../../../Services/LedgerService";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../../Users/Roles/UserSecurityFind";
import { useUser } from "../../../../Context/UserContext";
import { useClient } from "../../../Context/ClientContext";
import { SettingsSections } from "../../../Services/SettingService";
import { IPermissionActionType } from "../../Users/Roles/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../../Context/RoleContext";
import SalesInvoiceAndPurchaseBillGraph from "../InvoiceAndPurchaseBill/Table/SalesInvoiceAndPurchaseBillGraph";
import SalesAndPurchaseOrderGraph from "../Order/Table/SalesAndPurchaseOrderGraph";
import CreditAndDebitNotesTable from "../CreditAndDebitNote/Table/CreditAndDebitNotesTable";
import { Voucher_Type } from "../../../Services/VoucherServices";

const PurchaseNestedRoute = () => {
  const { clientSpecificRole } = useUser();
  const { currentClient } = useClient();
  return (
    <Routes>
      <Route
        path="/purchaseBill"
        element={
          findUserPremission(
            ["Voucher.Purchase.7.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.PurInvoice],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <SalesInvoiceAndPurchaseBillGraph
              voucherType={Voucher_Type.PurchaseVoucher}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/debitNote"
        element={
          findUserPremission(
            ["Voucher.Purchase.8.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.DrNote],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <CreditAndDebitNotesTable />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/paymentOut"
        element={
          findUserPremission(
            ["Voucher.Purchase.10.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.Payment],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <PaymentIn />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/order"
        element={
          findUserPremission(
            ["Voucher.Purchase.9.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.POrder],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <SalesAndPurchaseOrderGraph />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* <Route
        path="/items"
        element={<Items itemPage={ItemType.PurchaseItems} />}
      /> */}
      <Route
        path="/suppliers"
        element={
          findUserOnlyOnePremission(
            "Master.Ledger.Suppliers.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <LedgerTable
              ledgerByGroupsType={SearchLedgerByGroupsTypes.CreditorsOnly}
              showName={"Supplier"}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      ></Route>

      <Route path="*" element={<ResourceNotFound pageHeight="100%" />} />
    </Routes>
  );
};

export default PurchaseNestedRoute;
